module.exports = __webpack_public_path__ + "static/media/background-blend-light.934ea692.jpg";